<template>
  <div>
    <form v-on:submit.prevent="onSubmit">
      <v-toolbar class="primary elevation-0 small-extension" dark>
        <h1 class="titulo">Níveis de acesso</h1>
      </v-toolbar>
      <v-layout row wrap align-center class="secondary white--text detalhes-header">
        <v-flex xs2>
          <v-container fluid class="py-2">      
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <v-btn icon :to="({ name: 'RolesLista' })" class="ma-0 white--text">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs8>
          <v-container fluid class="py-2">      
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subtitulo">Adicionar nível de acesso</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs2>
          <v-container fluid class="py-2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                  <span class="subtitulo">Salvar</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 class="mb-3">
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.name"
                  label="Nome"
                  v-validate="'required'"
                  name="name"
                  data-vv-as="nome"
                  :error-messages="errors.has('name') ? errors.first('name') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 class="mt-4">
                <h6>Acessos Gerais</h6>
              </v-flex>
              <v-flex xs12 class="switch-fix mt-1">
                <strong>Administração de usuários</strong>
                <v-switch
                  v-model="form.fields.permissions.acessos_gerais.administracao_usuarios"
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong>Administração de níveis de acesso</strong>
                <v-switch
                  v-model="form.fields.permissions.acessos_gerais.administracao_niveis_acesso"
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong>Visualizar relatórios</strong>
                <v-switch
                  v-model="form.fields.permissions.acessos_gerais.visualizar_relatorios"
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <h6>Acesso a Imóveis</h6>
              </v-flex>
              <v-flex xs12 class="switch-fix mt-1">
                <strong>Acessar apenas imóveis com tarefas/vistorias atribuídas ao usuário (ex: fiscal)</strong>
                <v-switch
                  v-model="form.fields.limitado_tarefas"
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 class="switch-fix" v-if="!form.fields.limitado_tarefas">
                <strong>Acessar apenas imóveis de proprietários específicos</strong>
                <v-switch
                  v-model="form.fields.limitado_proprietario"
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 v-if="form.fields.limitado_proprietario">
                <v-select
                  multiple
                  v-bind:items="proprietarios"
                  v-model="form.fields.limitado_proprietario_lista"
                  label="Limitado aos imóveis do(s) proprietário(s) selecionado(s)"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="mt-4">
                <div class="permissions-table-wrap">
                  <table class="table">
                    <thead>
                      <tr>
                        <td>Categoria</td>
                        <td class="text-xs-center" v-for="action in actions" :key="action.id">
                          {{ action.name }}<br>
                          <small><u @click="toggleAllAction(action.id)" style="cursor: pointer">Marcar todos</u></small>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="category in categories" :key="category.id">
                        <td>
                          {{ category.name }}<br>
                          <small><u @click="toggleAllCategory(category.id)" style="cursor: pointer">Marcar todos</u></small>
                        </td>
                        <td v-for="action in actions" :key="action.id">
                          <v-checkbox
                            class="status_checkbox"
                            v-model="form.fields.permissions[category.id][action.id]" 
                            color="secondary"
                            hide-details
                          >
                          </v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'
  import { apiURL } from '@/config'

  export default {
    data () {
      return {
        categories: [
          { id: 'info', name: 'Info' },
          { id: 'endereco', name: 'Endereço' },
          { id: 'registro', name: 'Registros / Documentos' },
          { id: 'area', name: 'Área' },
          { id: 'taxas', name: 'IPTU / Impostos / Taxas' },
          { id: 'valor', name: 'Valor' },
          { id: 'status', name: 'Status' },
          { id: 'tarefas', name: 'Tarefas' },
          { id: 'vistoria', name: 'Vistoria' },
          { id: 'pagamentos', name: 'Pagamentos' },
          { id: 'fotos', name: 'Fotos' },
          { id: 'anexos', name: 'Anexos' },
          { id: 'observacoes', name: 'Observações' }
        ],
        actions: [
          { id: 'view', name: 'Visualizar' },
          { id: 'add', name: 'Adicionar' },
          { id: 'edit', name: 'Editar' },
          { id: 'delete', name: 'Apagar' }
        ],
        form: {
          fields: {
            name: '',
            limitado_tarefas: false,
            limitado_proprietario: false,
            limitado_proprietario_lista: [],
            permissions: {}
          }
        }
      }
    },
    created () {
      // Initialize permissions object
      this.$set(this.form.fields.permissions, 'acessos_gerais', {
        administracao_usuarios: false,
        administracao_niveis_acesso: false,
        visualizar_relatorios: false
      })

      this.categories.forEach(cat => {
        this.$set(this.form.fields.permissions, cat.id, {
          view: false,
          add: false,
          edit: false,
          delete: false
        })
      })
    },
    mounted () {
      this.$store.dispatch('imoveis/loadProprietarios')
    },
    computed: {
      proprietarios () {
        return this.$store.getters['imoveis/proprietarios']
      },
      isFormInvalid () {
        return !this.form.fields.name || this.errors.any()
      }
    },
    methods: {
      toggleAllAction (actionId) {
        const anyUnchecked = this.categories.some(cat => !this.form.fields.permissions[cat.id][actionId])
        this.categories.forEach(cat => {
          this.form.fields.permissions[cat.id][actionId] = anyUnchecked
        })
      },
      toggleAllCategory (catId) {
        const anyUnchecked = this.actions.some(act => !this.form.fields.permissions[catId][act.id])
        this.actions.forEach(act => {
          this.form.fields.permissions[catId][act.id] = anyUnchecked
        })
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const data = {
              name: this.form.fields.name,
              limitado_tarefas: this.form.fields.limitado_tarefas,
              limitado_proprietario: this.form.fields.limitado_proprietario,
              proprietarios: this.form.fields.limitado_proprietario ? this.form.fields.limitado_proprietario_lista : [],
              permissions: this.form.fields.permissions
            }

            axios.post(`${apiURL}/roles`, data).then((response) => {
              this.$store.dispatch('utils/showSnackbar', {
                persistent: true,
                type: 'success',
                text: `O nível de acesso ${response.data.data.name} foi criado com sucesso!`
              })
              this.$store.dispatch('utils/hideLoading')
              this.$router.push({ name: 'RolesLista' })
            }, (error) => {
              const isForbidden = error && error.response && error.response.status === 403
              this.$store.dispatch('utils/showSnackbar', {
                text: isForbidden ? 'Sem permissão para criar níveis de acesso.' : 'Erro ao salvar nível de acesso. Verifique os dados.'
              })
              this.$store.dispatch('utils/hideLoading')
              if (isForbidden) {
                this.$router.push('/')
              }
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>

<style scoped>
  @media (max-width: 959px) {
    .permissions-table-wrap {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .permissions-table-wrap .table {
      min-width: 640px;
    }
  }
</style>



// WEBPACK FOOTER //
// RolesAdicionar.vue?21bacedf